<template>
  <div>
    <v-simple-table>
      <thead>
        <tr>
          <th></th>
          <th colspan="3" class="text-center">
            {{ $tc('active_vehicle', 2) }}
            <info-tooltip class="text-dark ml-1" :text="$tc('reports_ui.customer_metrics_report.active_vehicles_tooltip')"/>
          </th>
          <th colspan="2" class="text-center">
            {{ $tc('route', 2) }}
            <info-tooltip class="text-dark ml-1" :text="$tc('reports_ui.customer_metrics_report.route_count_tooltip')"/>
          </th>
        </tr>
        <tr>
          <th>{{ $tc('customer') }}</th>
          <th style="width: 7rem">{{ $t('current') }}</th>
          <th style="width: 7rem">{{ $t('unassigned') }}</th>
          <th style="width: 9rem">{{ $t('as_of_date', { dateString: formatSnapshotActiveHeader() }) }}</th>
          <th style="width: 7rem">{{ $t('month_to_date') }}</th>
          <th style="width: 7rem">{{ formatSnapshotRoutesHeader() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(customer, index) in customers" :key="index">
          <td v-if="!customer.parent_id">
            <router-link :to="`/customer/${customer.customer_id}`">
              <v-icon color="primary">mdi-account-group</v-icon> {{ customer.name }}
            </router-link>
          </td>
          <td v-else>
            <router-link :to="`/customer/${customer.customer_id}`" class="pl-3">
              <v-icon color="primary">mdi-account</v-icon> {{ customer.name }}
            </router-link>
          </td>
          <td>{{ customer.active_vehicle_count }}</td>
          <td>{{ customer.parent_customer_active_vehicle_count }}</td>
          <td>{{ customer.last_active_vehicle_count }}</td>
          <td>{{ customer.monthly_route_count }}</td>
          <td>{{ customer.last_monthly_route_count }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>{{ $t('totals') }}</td>
          <td>{{ totals.activeVehicleCountTotal }}</td>
          <td>{{ totals.parentCustomerActiveVehicleCountTotal }}</td>
          <td>{{ totals.lastActiveVehicleCountTotal }}</td>
          <td>{{ totals.monthlyRouteCountTotal }}</td>
          <td>{{ totals.lastMonthlyRouteCountTotal }}</td>
        </tr>
      </tfoot>
    </v-simple-table>
    <div class="d-flex justify-content-between">
      <p>{{ $t('reports_ui.customer_metrics_report.data_as_of', { dateString: formatReportAsOfDateFooter() }) }}</p>
    </div>
  </div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ReportRecord from '@/orm/models/ReportRecord'
import InfoTooltip from '@/components/shared/InfoTooltip'
import Moment from 'moment-timezone'
import { get } from 'lodash'

export default {
  name: 'MissedStopsReport',
  components: {
    InfoTooltip
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {
    }
  },
  computed: {
    /**
     * @return array
     */
    customers () {
      return Object.values(get(this, 'report.results.customer_data') || {})
    },
    /**
     * @return object
     */
    totals () {
      let activeVehicleCountTotal = 0
      let parentCustomerActiveVehicleCountTotal = 0
      let lastActiveVehicleCountTotal = 0
      let monthlyRouteCountTotal = 0
      let lastMonthlyRouteCountTotal = 0

      for (const customer of this.customers) {
        if (!customer.parent_id) {
          activeVehicleCountTotal += customer.active_vehicle_count
          parentCustomerActiveVehicleCountTotal += customer.parent_customer_active_vehicle_count
          lastActiveVehicleCountTotal += customer.last_active_vehicle_count
          monthlyRouteCountTotal += customer.monthly_route_count
          lastMonthlyRouteCountTotal += customer.last_monthly_route_count
        }
      }

      return {
        activeVehicleCountTotal,
        parentCustomerActiveVehicleCountTotal,
        lastActiveVehicleCountTotal,
        monthlyRouteCountTotal,
        lastMonthlyRouteCountTotal
      }
    }
  },
  methods: {
    /**
     * Format the snapshot date for the active vehicles "as of" column
     * @returns {*}
     */
    formatSnapshotActiveHeader () {
      const dateString = get(this.report.results, 'snapshot_date')
      if (dateString) {
        return Moment.tz(dateString, 'UTC').format('L')
      }
    },
    /**
     * Format the snapshot date for the snapshot months column
     * @returns {*}
     */
    formatSnapshotRoutesHeader () {
      return Moment.tz(this.report.parameters.compareDate, 'UTC').format('MMM Y')
    },
    /**
     * Format the report run date for display in the footer as an "as of" date.
     * @returns {*}
     */
    formatReportAsOfDateFooter () {
      return Moment(this.report.parameters.report_run_date).format('LLLL')
    }
  }
}
</script>

<style scoped>
  .table thead tr:first-child th { /* first header row cells */
    border-bottom-width: 0; /* prevent appearance of thick line between header rows */
  }
  .table thead tr:first-child + tr th:first-child { /* second header row's first column */
    border-top-width: 0; /* give the appearance that the first column's cells are one */
  }
</style>
